import { render } from "./AssessmentDetails.vue?vue&type=template&id=02d1727b"
import script from "./AssessmentDetails.vue?vue&type=script&lang=js"
export * from "./AssessmentDetails.vue?vue&type=script&lang=js"

import "./AssessmentDetails.vue?vue&type=style&index=0&id=02d1727b&lang=less"

import exportComponent from "F:\\work\\git\\yunchi\\yc-vue-source\\cloud_share_lib\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__